export enum IrpfRetentionTypeEnum {
    yes = "yes",
    no = "no"
}


export class IrpfRetentionType {
    constructor(
        public readonly id: IrpfRetentionTypeEnum,
        public readonly label: string,
    ) { }
}